// extracted by mini-css-extract-plugin
export var articlesCount = "author-module--articles-count--45a99";
export var authorDescription = "author-module--author-description--70764";
export var authorImg = "author-module--author-img--f8373";
export var authorName = "author-module--author-name--922ae";
export var authorWrapper = "author-module--author-wrapper--24b60";